// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */

/* Panel Styles */
.panel {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 5px;
    margin-bottom: 20px;
    padding: 15px;
}

.panel-heading {
    background-color: #007bff;
    color: #ffffff;
    padding: 10px 15px;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin-top: 0; /* Ensure no margin at the top */
}

/* Ensure no unintended borders or margins */
.panel-heading:first-child {
    border-top: none;
}

.panel-body {
    padding: 15px;
}

/* Form Styles */
.form-group {
    margin-bottom: 15px;
}

.form-check-input {
    margin-right: 10px;
}

.form-check-label {
    margin-right: 20px;
}

.error {
    color: #ff0000;
    font-weight: bold;
}

.alert-box {
    padding: 10px;
    border: 1px solid #ff0000;
    border-radius: 5px;
    background-color: #ffe6e6;
}

.btn {
    padding: 15px;
    line-height: 1.5;
}

.btn-primary {
    background-color: #007bff;
    border: none;
}

.btn-secondary {
    background-color: #6c757d;
    border: none;
}

.mt-2 {
    margin-top: 20px;
}

.mt-3 {
    margin-top: 30px;
}

.bold {
    font-weight: bold;
}
.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
}

.add-menu-button {
    margin-left: auto;
}

.add-menu-button a {
    text-decoration: none;
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border-radius: 4px;
}

.add-menu-button a:hover {
    background-color: #0056b3;
}
.modal-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding-left: 250px; /* Adjust based on your sidebar width */
}

.modal-content {
    background-color: white;
    box-shadow: 0 8px 16px rgba(0,0,0,0.2);
    padding: 20px;
    border-radius: 8px;
    width: 90%;
    max-width: 900px;
    max-height: 80vh;
    overflow-y: auto;
    overflow-x: hidden;
}`, "",{"version":3,"sources":["webpack://./src/pages/configurations/config.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf,iBAAiB;AACjB;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa,EAAE,gCAAgC;AACnD;;AAEA,4CAA4C;AAC5C;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,gBAAgB;AAChB;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB,EAAE,uCAAuC;AAChE;;AAEA;IACI,uBAAuB;IACvB,sCAAsC;IACtC,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":["/* styles.css */\n\n/* Panel Styles */\n.panel {\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    padding: 15px;\n}\n\n.panel-heading {\n    background-color: #007bff;\n    color: #ffffff;\n    padding: 10px 15px;\n    border-bottom: 1px solid #dee2e6;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n    margin-top: 0; /* Ensure no margin at the top */\n}\n\n/* Ensure no unintended borders or margins */\n.panel-heading:first-child {\n    border-top: none;\n}\n\n.panel-body {\n    padding: 15px;\n}\n\n/* Form Styles */\n.form-group {\n    margin-bottom: 15px;\n}\n\n.form-check-input {\n    margin-right: 10px;\n}\n\n.form-check-label {\n    margin-right: 20px;\n}\n\n.error {\n    color: #ff0000;\n    font-weight: bold;\n}\n\n.alert-box {\n    padding: 10px;\n    border: 1px solid #ff0000;\n    border-radius: 5px;\n    background-color: #ffe6e6;\n}\n\n.btn {\n    padding: 15px;\n    line-height: 1.5;\n}\n\n.btn-primary {\n    background-color: #007bff;\n    border: none;\n}\n\n.btn-secondary {\n    background-color: #6c757d;\n    border: none;\n}\n\n.mt-2 {\n    margin-top: 20px;\n}\n\n.mt-3 {\n    margin-top: 30px;\n}\n\n.bold {\n    font-weight: bold;\n}\n.header-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n}\n\n.add-menu-button {\n    margin-left: auto;\n}\n\n.add-menu-button a {\n    text-decoration: none;\n    padding: 10px 20px;\n    background-color: #007bff;\n    color: white;\n    border-radius: 4px;\n}\n\n.add-menu-button a:hover {\n    background-color: #0056b3;\n}\n.modal-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    padding-left: 250px; /* Adjust based on your sidebar width */\n}\n\n.modal-content {\n    background-color: white;\n    box-shadow: 0 8px 16px rgba(0,0,0,0.2);\n    padding: 20px;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 900px;\n    max-height: 80vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
